

import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useKycVerification, shouldRestrictRoute } from '../../shared/hooks/useKycVerification';
import { KycVerificationDialog } from '../../shared/components/ui/Dialog/KycVerificationDialog';

interface KycProtectedRouteProps {
  children: React.ReactNode;
}

export const KycProtectedRoute: React.FC<KycProtectedRouteProps> = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { isFullyVerified } = useKycVerification();

  // Check if current route should be restricted
  const shouldRestrict = shouldRestrictRoute(location.pathname, isFullyVerified);

  const handleModalClose = () => {
    // Navigate to home page when user closes the modal
    navigate('/');
  };

  // If route is restricted, show ONLY the modal (block page content)
  if (shouldRestrict) {
    return (
      <KycVerificationDialog
        isOpen={true}
        onClose={handleModalClose}
      />
    );
  }

  // If not restricted (either verified OR exempt route), render children
  return <>{children}</>;
};
